import { Permission, UserData } from "src/shared/api/rbac/types";

export const extractPermissions = (user?: UserData): string[] => {
  if (user) {
    return user.permissions.map((p: Permission) => p.name);
  }

  return [];
};
